import { AsyncComponentDataStatus } from '../../state/types';
import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';
import debounce from 'lodash.debounce';
import { initAvailableDays } from '../../../../adapters/initWidgetData/initAvailableDays/initAvailableDays';

export const createOnWeekChangeAction: DailyAgendaActionFactory<
  DailyAgendaActions['onWeekChange']
> = ({ setState, flowAPI, getState }) => {
  const fetchData = async () =>
    initAvailableDays({ flowAPI, setState, getState });

  const debouncedFetchData = debounce(fetchData, 250);

  return async ({ from, to }) => {
    setState({
      availableDays: { status: AsyncComponentDataStatus.LOADING },
      selectedRange: {
        from: new Date(from),
        to: new Date(to),
      },
    });

    await debouncedFetchData();
  };
};
